// fetchLivestreamChatPreflight.js
'use strict';
import fetch from '../resource/customFetch.js';
import getMeData from '../selector/getMeData.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';
import {
  MERGE_OPERATION_DATA,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch livestream chat preflight
 * @kind action
 * @param {string} {streamId} - action param.
 * @return {Promise} Action promise.
 */
const fetchLivestreamChatPreflight =
  ({ streamId }) =>
  async (dispatch, getState) => {
    const token = getMeData(getState(), 'token');
    if (!streamId || !token) return dispatch({ type: '' });

    const selectPath = ['liveStream', streamId, 'chat', 'preflight'];

    const fetchOptions = {
      method: 'POST',
      headers: {
        ...getHeaders(),
        Authorization: `Bearer ${token}`,
      },
    };

    const url = getResourceUrl({
      endpoint: `/streams/${streamId}/chat/preflight`,
    });

    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });
    try {
      let response = await fetch(url.href, fetchOptions);

      if (!response.ok) {
        if (response.status === 403) {
          const { code } = await response
            .clone()
            .json()
            .catch(() => ({}));

          if (code === 'MISSING_SCOPES') {
            return dispatch({
              type: SET_NETWORKING_SUCCESS,
              payload: { selectPath },
            });
          }
        }

        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: url,
        });
      }

      const { exp } = await response.json();
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath,
          data: {
            exp,
          },
        },
      });

      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default fetchLivestreamChatPreflight;
